import React from "react";
import Styles from "./SwitchKey.module.scss";

const SwitchKey = ({ active = false, handleOnChange }) => {

  return (
    <div className={`${Styles.SwitchKeyWrapper} d-flex align-items-center justify-content-center`}>
      <input onChange={handleOnChange} type="checkbox" checked={active} />
    </div>
  )
}

export default SwitchKey;